<template>
	<div class="repertContainer">
    <md-field>
      <md-input-item
        title="當前密碼"
        v-model="user.oldPassword"
        placeholder="請輸入當前密碼"
      />
      <md-input-item
        title="新密碼"
        v-model="user.password"
        placeholder="請輸入新密碼"
      />
      <md-input-item
        title="確認新密碼"
        v-model="user.agginpas"
        placeholder="請再次輸入當前密碼"
      no-border/>
    </md-field>
    <md-button :loading="loading" type="warning" style="margin-top: 1rem" @click="submitpas">提交</md-button>
  </div>
</template>

<script>
import { Field, FieldItem, Button, InputItem, Toast, Dialog } from 'mand-mobile';
import md5 from "js-md5";
export default {
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [FieldItem.name]: FieldItem,
    [InputItem.name]: InputItem
  },
  name: 'repertPassward',
  data () {
    return {
      user: {
        oldPassword: '',
        password: '',
        agginpas: ''
      },
      loading: false
    }
  },
  methods: {
    isNumberOr_Letter (s) {
      var reg1 = /^(?=.*[0-9])(?=.*[A-Za-z])(?=.*[^A-Za-z0-9]).{8,}$/;
      if (reg1.test(s)) {
        return true
      } else {
        return false
      }
    },
    submitpas () {
      if (!this.user.oldPassword) {
        Toast.failed('請輸入當前密碼')
        return
      }
      if (!this.isNumberOr_Letter(this.user.password)) {
        Toast.failed('密码至少8位数字，英文，符号组合而成')
        return
      }
      if (!this.user.agginpas) {
        Toast.failed('請再次輸入當前密碼')
        return
      }
      if (this.user.agginpas != this.user.password) {
        Toast.failed('兩次密碼不一致')
        return
      }
      if (this.user.password === this.user.oldPassword) {
        Toast.failed('新密碼和當前密碼一致')
        return
      }
      // 111
      const param = JSON.parse(JSON.stringify(this.user));
      param.oldPassword = md5(param.oldPassword)
      param.password = md5(param.password)
      param.agginpas = md5(param.agginpas)
      this.loading = true
      this.http.APIASK(this.ports.updatePassword, 'post', param).then(res => {
        this.loading = false
        Toast.succeed('修改成功')
        this.$router.go(-1)
      }).catch(err => {
        this.loading = false
      });
    }
  }
}
</script>

<style lang="less">
  .repertContainer{
    .md-field-item-content:before{
      content: "";
      position: absolute;
      z-index: 2;
      -webkit-transform: scaleY(.5) translateY(100%);
      transform: scaleY(.5) translateY(100%);
      bottom: 0;
      left: 0;
      right: auto;
      top: auto;
      width: 100%;
      border-bottom: 0.02rem solid #e2e4ea;
      -webkit-transform-origin: 50% 100%;
      transform-origin: 50% 100%;
    }
      .md-field{
        padding: 0 0.4rem;
      }
      .md-field-item-title{
        text-align: left;
      }
    }

</style>
